export const BREAKPOINT_DESKTOP_START = 992;
export const BREAKPOINT_MOBILE_END = 991;
export const BREAKPOINT_XGA = 1024;
export const BREAKPOINT_SXGA = 1280;
export const BREAKPOINT_TABLET = 800;
export const BREAKPOINT_SMALL = 600; // mui default sm breakpoint - https://mui.com/material-ui/customization/breakpoints/
